export const translate = (key, ...params) => {
    let translatedString = window.__litium.translation[key] || key;

    params.forEach((param, index) => {
        const placeholder = new RegExp(`\\{${index}\\}`, 'g')
        translatedString = translatedString.replace(placeholder, param);
    });

    return translatedString;
}